import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing } from "lucide-react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/datetime";

export function NewEnquiriesBanner() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let live = true;
    const load = () => api.get("/tasks-inbound/new").then((r) => live && setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { live = false; clearInterval(t); };
  }, []);
  if (!d?.count) return null;
  return (
    <div className="mb-4 rounded-xl border border-sky-200 bg-sky-50" data-testid="new-enquiries-banner">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-4 py-2.5 text-left cursor-pointer" data-testid="new-enquiries-toggle">
        <BellRing className="w-4 h-4 text-sky-600 shrink-0" />
        <span className="text-sm font-semibold text-sky-800" data-testid="new-enquiries-count">{d.count} new {d.count === 1 ? "enquiry" : "enquiries"} not opened yet</span>
        <span className="ml-auto text-xs text-sky-700 underline">{open ? "Hide" : "Show"}</span>
      </button>
      {open && (
        <ul className="border-t border-sky-200 divide-y divide-sky-100" data-testid="new-enquiries-list">
          {d.items.map((j) => (
            <li key={j.legacy_id}>
              <Link to={`/tasks/${j.legacy_id}`} className="flex flex-wrap items-center gap-x-3 gap-y-0.5 px-4 py-2 text-sm hover:bg-sky-100/60" data-testid={`new-enquiry-${j.legacy_id}`}>
                <span className="font-medium text-slate-900">{j.title}</span>
                <span className="text-xs text-slate-500">{j.enquiry_source || "Automatic enquiry"}{j.venue_postcode ? ` · ${j.venue_postcode}` : ""}</span>
                <span className="ml-auto text-xs text-slate-400">{formatDateTime(j.created_at)}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
